"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// checkbox, radio group, switch

const defaultProps = {
  color: 'inputElements'
};
var _default = exports.default = {
  defaultProps
};
//# sourceMappingURL=MuiFormLabel.js.map